<template>
  <el-dialog title="Adicionar Lançamento Futuro" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="400px">
    <el-form :rules="validacao" ref="form" size="small" :model="lancamentoFuturo" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="perfilClienteLancFuturo" label="Cliente">
            <el-select v-model="lancamentoFuturo.perfilClienteLancFuturo" style="width:100%;">
              <el-option label="" value=""/>
              <el-option label="Proprietário" value="PROPRIETARIO"/>
              <el-option label="Locatário" value="LOCATARIO"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="mesSerie" label="Mês Série">
            <el-input v-model="lancamentoFuturo.mesSerie" v-mask="'###'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="tipo" label="Tipo">
            <el-select style="width:100%;" v-model="lancamentoFuturo.tipo">
              <el-option label="" value=""/>
              <el-option label="Débito" value="DEBITO"/>
              <el-option label="Crédito" value="CREDITO"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="nome" label="Descrição">
            <el-input v-model="lancamentoFuturo.nome"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Valor" prop="valor">
          <div class="el-input el-input--small">
            <money
              v-model="lancamentoFuturo.valor"
              v-bind="money"
              class="el-input__inner"
            />
          </div>
        </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Repetir por mais">
            <el-input v-model="lancamentoFuturo.quantidadeMeses" v-mask="'##'">
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="gravarHandler()" type="primary" size="small" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Money } from "v-money";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Money
  },
  props: {
    visibility: Boolean
  },
  data() {
    return {
      lancamentoFuturo: {
        id: 0,
        valor: 0,
        perfilClienteLancFuturo: '',
        categoria: 'OUTROS',
        imovel: {
          id: 0
        },
        quantidadeMeses: 0
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      validacao: {
        perfilClienteLancFuturo: [{ required: true }],
        mesSerie: [{ required: true }],
        tipo: [{ required: true }],
        nome: [{ required: true }],
        valor: [{ required: true, validator: this.validadorValor }]
      }
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    ...mapState("alugueisImoveisStore", {
      imovel(state) {
        return state.imovelSelecionado;
      },
    })
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("alugueisImoveisStore", ["gravarLancamentoFuturo"]),

    validadorValor(rule, value, callback) {
      if(value > 0) {
        return callback();
      } else {
        return callback(new Error());
      }
    },

    gravarHandler(){
      this.lancamentoFuturo.imovel = { id: this.imovel.id }
      this.$refs['form'].validate(elFormIsValid => {
        const formIsInvalid = !elFormIsValid;
        if(formIsInvalid) {
          this.exibirAlerta("Preencha todos os campos obrigatórios");
          return
        }
          this.gravar();
      })
    },

    gravar() {
      this.showLoading();
      this.gravarLancamentoFuturo(this.lancamentoFuturo)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
            break;
        }
        this.fechar();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
        this.fechar();
      });
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
    },

    reset() {
      this.lancamentoFuturo = {}
    },

    fechar() {
      this.reset();
      this.$emit('close');
    }, 
  }
}
</script>
